import styled from '@emotion/styled'
import WhyUsBackground from '../../../../assets/why_us_bg.png'

export const Container = styled.div`
  align-items: center;
  background: url(${WhyUsBackground});
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 2rem 0;
  position: relative;
  width: 100%;

  @media (max-width: 768px) {
    padding: 2rem 2rem;

    & button {
      width: 100%;
    }
  }
`
